/*
 * @Author: Czy
 * @Date: 2025-01-20 09:53:47
 * @FilePath: /bikecat/src/interceptors/route.ts
 *
 */
/**
 * 路由拦截器 - 已移除登录拦截，所有页面均可直接访问
 */
import { useSysStore } from '@/store'

// 路由拦截器 - 不再做登录校验
const navigateToInterceptor = {
  invoke({ url }: { url: string }) {
    const pages = getCurrentPages()
    const currentPage = pages[pages.length - 1]
    const pageName = currentPage.route

    console.log('跳转', pageName, url)
    if (`/${pageName}` == url) return true

    useSysStore().isOldPage = url

    return true
  },
}

export const routeInterceptor = {
  install() {
    uni.addInterceptor('navigateTo', navigateToInterceptor)
    uni.addInterceptor('reLaunch', navigateToInterceptor)
    uni.addInterceptor('redirectTo', navigateToInterceptor)
  },
}
